##
# Put this directive on any inner ngForm element and it will removed from any parent form controls
# (e.g. validation, pristine check)
#
# **Usage**
# as attribute:
# <ANY ng-form>
#	    <ANY
#         ng-form
#	        data-form-ignore-all
#     ></ANY>
# </ANY>
#
# @see https://stackoverflow.com/questions/19333544/skip-nested-forms-validation-with-angularjs/37481846#37481846
##
angular
	.module 'App.Directive'
	.directive 'formIgnoreAll', ->
		restrict: 'A'
		require: '?form'
		link: (scope, element, attributes, formCtrl) ->
			return if !formCtrl

			parentForm = formCtrl.$$parentForm # Note this uses private API

			return if !parentForm

			# Remove current form from parent controller
			parentForm.$removeControl(formCtrl)
